import React from "react";
import { MoreVertical } from "lucide-react";
import { Button } from "../ui/button.tsx";
import SubjectActions from "./SubjectActions";

export default function SubjectTable({ subjects = [], isLoading = false, onEditSubject, onDeleteSubject }) {
  // Ensure subjects is an array
  const subjectsList = Array.isArray(subjects) ? subjects : [];
  
  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    
    return new Intl.DateTimeFormat('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    }).format(date);
  };

  if (isLoading) {
    return (
      <div className="p-8 text-center">
        <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-blue-600 border-r-transparent"></div>
        <p className="mt-2 text-gray-500">Loading subjects...</p>
      </div>
    );
  }

  if (subjectsList.length === 0) {
    return (
      <div className="p-8 text-center">
        <p className="text-gray-500">No subjects found. Create your first subject using the "Add Subject" button.</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse">
        <thead>
          <tr className="bg-gray-50 text-left text-xs uppercase tracking-wider">
            <th className="px-4 py-3 font-medium text-gray-500">Name</th>
            <th className="px-4 py-3 font-medium text-gray-500">Code</th>
            <th className="px-4 py-3 font-medium text-gray-500">Department</th>
            <th className="px-4 py-3 font-medium text-gray-500">Enrolled</th>
            <th className="px-4 py-3 font-medium text-gray-500">Date Created</th>
            <th className="px-4 py-3 font-medium text-gray-500">Status</th>
            <th className="px-4 py-3 font-medium text-gray-500">Actions</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {subjectsList.map((subject, index) => (
            <tr key={subject.id || index} className="text-sm">
              <td className="px-4 py-4">{subject.name}</td>
              <td className="px-4 py-4">{subject.code}</td>
              <td className="px-4 py-4">{subject.department?.name || 'N/A'}</td>
              <td className="px-4 py-4">{subject.enrolled || 0}</td>
              <td className="px-4 py-4">{formatDate(subject.createdAt)}</td>
              <td className="px-4 py-4">
                <div className="flex items-center">
                  <span className={`inline-block h-2 w-2 rounded-full mr-2 ${subject.status === 'Active' ? 'bg-green-400' : 'bg-red-400'}`}></span>
                  <span className="text-gray-600">{subject.status || 'Active'}</span>
                </div>
              </td>
              <td className="px-4 py-4">
                <SubjectActions 
                  subject={subject} 
                  onEdit={onEditSubject} 
                  onDelete={onDeleteSubject} 
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}